import React, { useState } from 'react';
import api from '../../services/api';
import Notification from '../common/Notification';
import Authorization from '../common/Authorization';

const Signup = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobileNumber: '',
    companyName: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const [notification, setNotification] = useState(null);

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === 'mobileNumber') {
      if (!/^\d*$/.test(value)) return;
    }
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const payload = {
      mobileNumber: formData.mobileNumber || '1234567890',
      countryId: "+91",
      firstName: formData.firstName,
      lastName: formData.lastName,
      businessEmail: formData.email,
      departmentId: 1,
      jobTittleId: 1,
      companyName: formData.companyName,
      verificationEmail: formData.email,
      companySizeId: 1,
      active: true,
      orgId: 5,
      sourcefrom: ""
    };

    try {
      await api.auth.signup(payload);
      setMessage('User created successfully! Please check your email to verify your account.');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
        companyName: ''
      });
    }
    catch (error) {
      setNotification({ message: "Error during signup: " + error.message, type: "error" });
    } finally {
      setLoading(false);
    }
  };
  const formatLabel = (field) => {
    const label = field === 'email' ? 'Business Email' : field.replace(/([A-Z])/g, ' $1');
    return label.charAt(0).toUpperCase() + label.slice(1);
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <Authorization />
      <div className="w-full md:w-1/2 flex items-center justify-center py-5 px-4 md:px-0">
        <div className="w-full max-w-md">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 primary-heading px-0">Signup</h2>
          <form onSubmit={handleSubmit}>
            {['firstName', 'lastName', 'email', 'mobileNumber', 'companyName'].map((field) => (
              <div className="mb-4" key={field}>
                <label htmlFor={field} className="block text-sm font-medium text-gray-700">
                  {formatLabel(field)}
                  {field === 'mobileNumber' && <span className="text-gray-500 ml-1">(Optional)</span>}
                </label>
                <input
                  type={field === 'email' ? 'email' : field === 'mobileNumber' ? 'tel' : 'text'}
                  id={field}
                  value={formData[field]}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md custom-form-input"
                  inputMode={field === 'mobileNumber' ? 'numeric' : undefined}
                  maxLength={field === 'mobileNumber' ? 10 : undefined}
                  required={field !== 'mobileNumber'}
                />

              </div>
            ))}

            {message && <div className="mb-4 text-center text-green-500">{message}</div>}

            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <button
                type="submit"
                className="btn-blue-color text-white font-bold py-2 px-4 rounded-[10px] focus:outline-none focus:shadow-outline w-full md:w-auto"
                disabled={loading}
              >
                {loading ? 'Signing up...' : 'Sign up'}
              </button>
              <a href="/login" className="text-center md:text-left font-bold text-sm text-blue-600 hover:text-blue-800">
                <span className='gray-link-colour'>Already have an account?</span> Login
              </a>
            </div>
          </form>
        </div>
      </div>
      {/* Notification */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default Signup;
